export const comments_4987552 = {"data":{"data":[],"links":{}}}